import React from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "./NotFound.css";

const NotFound = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const isArabic = location.pathname.endsWith("/ar");

  if (isArabic) {
    return (
      <>
        <div className="NotFoundC">
          <h1 className="TGLo32PxPC NotFoundCT1">لم يتم العثور على الصفحة</h1>
          <p className="TFut24PxPC NotFoundCT2" dir="rtl">
            عذرا !! الصفحة التي تبحث عنها غير موجودة.
          </p>
          <div className="NotFoundCP2" dir="rtl">
            <button onClick={() => navigate(-1)} className=" FromWsubmitB ar TFut16PxPCUC">
              العودة للخلف
            </button>
            <Link to="/ar" className="NotFoundCB ar FromWsubmitB TFut16PxPCUC">
              اذهب إلى الصفحة الرئيسية
            </Link>
          </div>
        </div>
      </>
    );
  }

  return (
    <div className="NotFoundC">
      <h1 className="TGLo32PxPC">Page Not Found</h1>
      <p className="TFut24PxPC">Oops! The page you are looking for does not exist.</p>
      <div className="NotFoundCP2">
        <button onClick={() => navigate(-1)} className=" FromWsubmitB TFut16PxPCUC">
          Go Back
        </button>
        <Link to="/" className="NotFoundCB FromWsubmitB TFut16PxPCUC">
          Go to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
